<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex>
        <v-card>
          <v-toolbar flat>
            <v-toolbar-title>
              <v-icon left color="accent">mdi-package-variant-closed</v-icon>Purchase Orders
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn color="accent" outlined to="create">Create Purchase Order</v-btn>
            <template v-slot:extension>
              <v-tabs v-model="tabs">
                <v-tab>Draft</v-tab>
                <v-tab>Validated</v-tab>
                <v-tab>Partially Received</v-tab>
                <v-tab>Received</v-tab>
                <v-tab>Cancelled</v-tab>
                <v-tab>All</v-tab>
                <v-spacer></v-spacer>
                <v-tab>
                  <v-icon left>mdi-magnify</v-icon> Search
                </v-tab>
              </v-tabs>
            </template>
          </v-toolbar>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <PoTable :defaultFilter="{poStatus:'draft', skuVault:0}" :headers="headers" />
            </v-tab-item>
            <v-tab-item>
              <PoTable :defaultFilter="{poStatus:'validated', skuVault:0}" :headers="headers" />
            </v-tab-item>
            <v-tab-item>
              <PoTable :defaultFilter="{poStatus:'partialyReceived', skuVault:0}" :headers="headers" />
            </v-tab-item>
            <v-tab-item>
              <PoTable :defaultFilter="{poStatus:'received', skuVault:0}" :headers="headers" />
            </v-tab-item>
            <v-tab-item>
              <PoTable :defaultFilter="{poStatus:'cancel', skuVault:0}" :headers="headers" />
            </v-tab-item>
            <v-tab-item>
              <PoTable :defaultFilter="{skuVault:0}" :headers="headers" />
            </v-tab-item>
            <v-tab-item>
              <v-sheet color="blue-grey lighten-5">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <v-text-field
                        v-model="search.poNumber"
                        label="PO Number"
                        clearable
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="search.poStatus"
                        label="Status"
                        clearable
                        :items="['draft', 'validated', 'partially received', 'received', 'cancelled']"
                      />
                    </v-col>
                    <v-col>
                      <v-select
                        v-model="search.supplierId"
                        label="Suppliers"
                        clearable
                        :items="suppliers"
                        item-text="name"
                        item-value="id"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-sheet>
              <PoTable :defaultFilter="{...search, skuVault:0}" :headers="headers" />

            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

import PoTable from "@components/purchaseOrder/PoTable"
import { mapActions, mapGetters } from 'vuex';
export default {
  components: {
    PoTable,
  },
  data: () => ({
    tabs:null,
    search: {}
  }),
  computed:{
    ...mapGetters("supplier", {suppliers:'list'}),
    headers: function() {
      return [
        { text: "PO Number", value: "poNumber", align: "left", searchable: true},
        { text: "Order Date", value: "orderDate", align: "left" },
        { text: "Supplier", value: "supplier.name", align: "left", searchable: true, searchTerms:this.suppliers.map(i => ({text:i.name, value:i.name})) },
        { text: "Quantity", value: 'quantity' },
        { text: "Received", value: 'received' },
        { text: "Total", value: 'total' },
        { text: "Action", value: "action", align: "left" }
      ]
    },
  },
  mounted(){
    this.getSuppliers().then().catch()
  },
  methods:{
    ...mapActions("supplier", {
      getSuppliers: "allSuppliers"
    }),
  }
};
</script>
